import { z } from 'zod';
import { isMongoId } from '../../helpers';
import { TransactionOperation } from 'further-types/lp/transaction';
import { CurrencyCode, FxDataFeed } from 'further-types/lp/vehicle';
import { ActionTransactionSubTypes } from 'further-types/lp/action';

export const IndividualTransaction = z.object({
  id: z
    .string()
    .optional()
    .refine(isMongoId({ optional: true })),
  actionId: z
    .string()
    .optional()
    .refine(isMongoId({ optional: true })),
  transactionTypeId: z.string().refine(isMongoId()),
  amountExVatTcy: z.number(),
  amountIncVatTcy: z.number(),
  amountExVatLcy: z.number().optional().nullable(),
  amountIncVatLcy: z.number().optional().nullable(),
  reconciledAmountTcy: z.number().optional(),
  operationType: z.nativeEnum(TransactionOperation),
  transactionCurrency: z.nativeEnum(CurrencyCode),
  transactionSubType: z.nativeEnum(ActionTransactionSubTypes),
  transactionCurrencyRate: z
    .object({
      fetchedRate: z.number().optional(),
      fetchedSource: z.nativeEnum(FxDataFeed).optional(),
      overrideRate: z.number().optional(),
      overrideSource: z.string().optional(),
    })
    .optional(),
});

export const CreateTransactions = z.array(IndividualTransaction);

export const UpdateTransactions = z.array(
  IndividualTransaction.extend({
    id: z.string().refine(isMongoId()),
  }),
);
